"use strict";
/* tslint:disable: variable-name no-shadowed-variable max-file-line-count */
Object.defineProperty(exports, "__esModule", { value: true });
// From table A.2 in ASHRAE RP-1485
exports.knownVirialCoefficients = [
    createKnownVirialCoefficient(-60, -33.065, 2177.9, -11174, -1498938172, -68.306, 1027.3, -1821432),
    createKnownVirialCoefficient(-40, -25.223, 2061.7, -5712.7, -70675342, -55.836, 971.08, -795937),
    createKnownVirialCoefficient(-20, -18.845, 1968.7, -3253.2, -24128280, -46.007, 913.37, -401286),
    createKnownVirialCoefficient(0, -13.562, 1893.1, -2025.6, -10981960, -38.074, 861.02, -224234),
    createKnownVirialCoefficient(40, -5.3456, 1778.3, -966.89, -2708649, -26.083, 777.62, -86816),
    createKnownVirialCoefficient(80, 0.7203, 1696.1, -562.25, -788206, -17.478, 718.90, -40932),
    createKnownVirialCoefficient(120, 5.3551, 1634.9, -371.12, -260443, -11.025, 677.75, -22084),
    createKnownVirialCoefficient(160, 8.9916, 1588.1, -265.63, -94876, -6.0244, 648.46, -13147),
    createKnownVirialCoefficient(200, 11.905, 1551.2, -200.52, -37138, -2.0473, 627.15, -8436.5),
    createKnownVirialCoefficient(250, 14.806, 1515.2, -148.33, -12230, 1.8941, 607.92, -5257.5),
    createKnownVirialCoefficient(300, 17.101, 1487.1, -113.96, -4060.9, 5.0084, 594.10, -3516.7),
    createKnownVirialCoefficient(350, 18.949, 1464.7, -89.888, -1198.9, 7.5200, 583.79, -2486.9),
];
// Specifies the decimal count precision with which the values in table A.2 in ASHRAE RP-1485 are given
exports.knownVirialCoefficientsDecimalCount = [
    createKnownVirialCoefficient(-60, 3, 1, 0, 0, 3, 1, 0),
    createKnownVirialCoefficient(-40, 3, 1, 1, 0, 3, 2, 0),
    createKnownVirialCoefficient(-20, 3, 1, 1, 0, 3, 2, 0),
    createKnownVirialCoefficient(0, 3, 1, 1, 0, 3, 2, 0),
    createKnownVirialCoefficient(40, 4, 1, 2, 0, 3, 2, 0),
    createKnownVirialCoefficient(80, 4, 1, 2, 0, 3, 2, 0),
    createKnownVirialCoefficient(120, 4, 1, 2, 0, 3, 2, 0),
    createKnownVirialCoefficient(160, 4, 1, 2, 0, 4, 2, 0),
    createKnownVirialCoefficient(200, 3, 1, 2, 0, 4, 2, 1),
    createKnownVirialCoefficient(250, 3, 1, 2, 0, 4, 2, 1),
    createKnownVirialCoefficient(300, 3, 1, 2, 1, 4, 2, 1),
    createKnownVirialCoefficient(350, 3, 1, 3, 1, 4, 2, 1),
];
// From table A.3 in ASHRAE RP-1485
exports.knownVirialCoefficientsDerivatives = [
    createKnownVirialCoefficientDerivative(-60, 0.43679, -6.5260, 409.07, 325835981, 0.70671, -2.5329, 83652),
    createKnownVirialCoefficientDerivative(-40, 0.35183, -5.1687, 175.25, 5714038, 0.54983, -2.9397, 29767),
    createKnownVirialCoefficientDerivative(-20, 0.28903, -4.1730, 83.872, 1013012, 0.43911, -2.7799, 12605),
    createKnownVirialCoefficientDerivative(0, 0.24128, -3.4244, 44.006, 411997, 0.35825, -2.4427, 6053),
    createKnownVirialCoefficientDerivative(40, 0.17468, -2.4003, 15.148, 88681, 0.25067, -1.7468, 1816),
    createKnownVirialCoefficientDerivative(80, 0.13151, -1.7560, 6.5965, 22966, 0.18449, -1.2205, 692.64),
    createKnownVirialCoefficientDerivative(120, 0.10199, -1.3286, 3.4242, 6863.4, 0.14096, -0.86085, 310.91),
    createKnownVirialCoefficientDerivative(160, 0.080959, -1.0327, 2.0206, 2300.1, 0.11083, -0.61954, 157.10),
    createKnownVirialCoefficientDerivative(200, 0.065484, -0.82079, 1.3074, 845.21, 0.089144, -0.45655, 86.868),
    createKnownVirialCoefficientDerivative(250, 0.051319, -0.63212, 0.83107, 267.49, 0.069646, -0.32257, 45.692),
    createKnownVirialCoefficientDerivative(300, 0.041005, -0.49858, 0.56737, 91.737, 0.055658, -0.23649, 26.178),
    createKnownVirialCoefficientDerivative(350, 0.033288, -0.40113, 0.40768, 32.862, 0.045298, -0.17949, 16.047),
];
// Specifies the decimal count precision with which the values in table A.3 in ASHRAE RP-1485 are given
exports.knownVirialCoefficientsDerivativesDecimalCount = [
    createKnownVirialCoefficientDerivative(-60, 5, 4, 2, 0, 5, 4, 0),
    createKnownVirialCoefficientDerivative(-40, 5, 4, 2, 0, 5, 4, 0),
    createKnownVirialCoefficientDerivative(-20, 5, 4, 3, 0, 5, 4, 0),
    createKnownVirialCoefficientDerivative(0, 5, 4, 3, 0, 5, 4, 0),
    createKnownVirialCoefficientDerivative(40, 5, 4, 3, 0, 5, 4, 0),
    createKnownVirialCoefficientDerivative(80, 5, 4, 4, 0, 5, 4, 2),
    createKnownVirialCoefficientDerivative(120, 5, 4, 4, 1, 5, 5, 2),
    createKnownVirialCoefficientDerivative(160, 6, 4, 4, 1, 5, 5, 2),
    createKnownVirialCoefficientDerivative(200, 6, 5, 4, 2, 6, 5, 3),
    createKnownVirialCoefficientDerivative(250, 6, 5, 5, 2, 6, 5, 3),
    createKnownVirialCoefficientDerivative(300, 6, 5, 5, 3, 6, 5, 3),
    createKnownVirialCoefficientDerivative(350, 6, 5, 5, 3, 6, 5, 3),
];
// From table A.4 in ASHRAE RP-1485
exports.knownEnhancementFactors = [
    // 101.325 kPa
    createKnownEnhancementFactor(101.325, -60, 1.00708),
    createKnownEnhancementFactor(101.325, -40, 1.00560),
    createKnownEnhancementFactor(101.325, -20, 1.00464),
    createKnownEnhancementFactor(101.325, 0, 1.00410),
    createKnownEnhancementFactor(101.325, 40, 1.00483),
    createKnownEnhancementFactor(101.325, 80, 1.00573),
    createKnownEnhancementFactor(101.325, 120, 1.00000),
    createKnownEnhancementFactor(101.325, 160, 1.00000),
    createKnownEnhancementFactor(101.325, 200, 1.00000),
    createKnownEnhancementFactor(101.325, 250, 1.00000),
    createKnownEnhancementFactor(101.325, 300, 1.00000),
    createKnownEnhancementFactor(101.325, 350, 1.00000),
    // 200 kPa
    createKnownEnhancementFactor(200, -60, 1.01403),
    createKnownEnhancementFactor(200, -40, 1.01106),
    createKnownEnhancementFactor(200, -20, 1.00903),
    createKnownEnhancementFactor(200, 0, 1.00762),
    createKnownEnhancementFactor(200, 40, 1.00744),
    createKnownEnhancementFactor(200, 80, 1.00971),
    createKnownEnhancementFactor(200, 120, 1.00017),
    createKnownEnhancementFactor(200, 160, 1.00000),
    createKnownEnhancementFactor(200, 200, 1.00000),
    createKnownEnhancementFactor(200, 250, 1.00000),
    createKnownEnhancementFactor(200, 300, 1.00000),
    createKnownEnhancementFactor(200, 350, 1.00000),
    // 500 kPa
    createKnownEnhancementFactor(500, -60, 1.03562),
    createKnownEnhancementFactor(500, -40, 1.02793),
    createKnownEnhancementFactor(500, -20, 1.02256),
    createKnownEnhancementFactor(500, 0, 1.01844),
    createKnownEnhancementFactor(500, 40, 1.01520),
    createKnownEnhancementFactor(500, 80, 1.01689),
    createKnownEnhancementFactor(500, 120, 1.01839),
    createKnownEnhancementFactor(500, 160, 1.00000),
    createKnownEnhancementFactor(500, 200, 1.00000),
    createKnownEnhancementFactor(500, 250, 1.00000),
    createKnownEnhancementFactor(500, 300, 1.00000),
    createKnownEnhancementFactor(500, 350, 1.00000),
    // 1,000 kPa
    createKnownEnhancementFactor(1000, -60, 1.07310),
    createKnownEnhancementFactor(1000, -40, 1.05694),
    createKnownEnhancementFactor(1000, -20, 1.04569),
    createKnownEnhancementFactor(1000, 0, 1.03682),
    createKnownEnhancementFactor(1000, 40, 1.02823),
    createKnownEnhancementFactor(1000, 80, 1.02729),
    createKnownEnhancementFactor(1000, 120, 1.03123),
    createKnownEnhancementFactor(1000, 160, 1.02317),
    createKnownEnhancementFactor(1000, 200, 1.00000),
    createKnownEnhancementFactor(1000, 250, 1.00000),
    createKnownEnhancementFactor(1000, 300, 1.00000),
    createKnownEnhancementFactor(1000, 350, 1.00000),
    // 2,000 kPa
    createKnownEnhancementFactor(2000, -60, 1.15411),
    createKnownEnhancementFactor(2000, -40, 1.11855),
    createKnownEnhancementFactor(2000, -20, 1.09419),
    createKnownEnhancementFactor(2000, 0, 1.07503),
    createKnownEnhancementFactor(2000, 40, 1.05497),
    createKnownEnhancementFactor(2000, 80, 1.04789),
    createKnownEnhancementFactor(2000, 120, 1.05046),
    createKnownEnhancementFactor(2000, 160, 1.05320),
    createKnownEnhancementFactor(2000, 200, 1.02408),
    createKnownEnhancementFactor(2000, 250, 1.00000),
    createKnownEnhancementFactor(2000, 300, 1.00000),
    createKnownEnhancementFactor(2000, 350, 1.00000),
    // 5,000 kPa
    createKnownEnhancementFactor(5000, -60, 1.45512),
    createKnownEnhancementFactor(5000, -40, 1.33628),
    createKnownEnhancementFactor(5000, -20, 1.25977),
    createKnownEnhancementFactor(5000, 0, 1.20214),
    createKnownEnhancementFactor(5000, 40, 1.14128),
    createKnownEnhancementFactor(5000, 80, 1.11282),
    createKnownEnhancementFactor(5000, 120, 1.10536),
    createKnownEnhancementFactor(5000, 160, 1.11067),
    createKnownEnhancementFactor(5000, 200, 1.11078),
    createKnownEnhancementFactor(5000, 250, 1.04242),
    createKnownEnhancementFactor(5000, 300, 1.00000),
    createKnownEnhancementFactor(5000, 350, 1.00000),
    // 10,000 kPa
    createKnownEnhancementFactor(10000, -60, 2.23918),
    createKnownEnhancementFactor(10000, -40, 1.84523),
    //createKnownEnhancementFactor(10000, -20, 1.61953), NB: Seems to be incorrect?
    createKnownEnhancementFactor(10000, 0, 1.46383),
    createKnownEnhancementFactor(10000, 40, 1.30824),
    createKnownEnhancementFactor(10000, 80, 1.23434),
    createKnownEnhancementFactor(10000, 120, 1.20482),
    createKnownEnhancementFactor(10000, 160, 1.20315),
    createKnownEnhancementFactor(10000, 200, 1.21286),
    createKnownEnhancementFactor(10000, 250, 1.19032),
    createKnownEnhancementFactor(10000, 300, 1.04804),
    createKnownEnhancementFactor(10000, 350, 1.00000),
];
// From table A.6 in ASHRAE RP-1485
exports.knownHenrysLawConstants = [
    // 101.325 kPa
    createKnownHenrysLawConstant(101.325, 0, 0.22600),
    createKnownHenrysLawConstant(101.325, 40, 0.11676),
    createKnownHenrysLawConstant(101.325, 80, 0.09566),
    // 200 kPa
    createKnownHenrysLawConstant(200, 0, 0.22600),
    createKnownHenrysLawConstant(200, 40, 0.11676),
    createKnownHenrysLawConstant(200, 80, 0.09566),
    createKnownHenrysLawConstant(200, 120, 0.10310),
    // 500 kPa
    createKnownHenrysLawConstant(500, 0, 0.22600),
    createKnownHenrysLawConstant(500, 40, 0.11676),
    createKnownHenrysLawConstant(500, 80, 0.09566),
    createKnownHenrysLawConstant(500, 120, 0.10310),
    // 1,000 kPa
    createKnownHenrysLawConstant(1000, 0, 0.22600),
    createKnownHenrysLawConstant(1000, 40, 0.11676),
    createKnownHenrysLawConstant(1000, 80, 0.09566),
    createKnownHenrysLawConstant(1000, 120, 0.10310),
    createKnownHenrysLawConstant(1000, 160, 0.13116),
    // 2,000 kPa
    createKnownHenrysLawConstant(2000, 0, 0.22600),
    createKnownHenrysLawConstant(2000, 40, 0.11676),
    createKnownHenrysLawConstant(2000, 80, 0.09566),
    createKnownHenrysLawConstant(2000, 120, 0.10310),
    createKnownHenrysLawConstant(2000, 160, 0.13116),
    createKnownHenrysLawConstant(2000, 200, 0.18490),
    // 5,000 kPa
    createKnownHenrysLawConstant(5000, 0, 0.22600),
    createKnownHenrysLawConstant(5000, 40, 0.11676),
    createKnownHenrysLawConstant(5000, 80, 0.09566),
    createKnownHenrysLawConstant(5000, 120, 0.10310),
    createKnownHenrysLawConstant(5000, 160, 0.13116),
    createKnownHenrysLawConstant(5000, 200, 0.18490),
    createKnownHenrysLawConstant(5000, 250, 0.31259),
    // 10,000 kPa
    createKnownHenrysLawConstant(10000, 0, 0.22600),
    createKnownHenrysLawConstant(10000, 40, 0.11676),
    createKnownHenrysLawConstant(10000, 80, 0.09566),
    createKnownHenrysLawConstant(10000, 120, 0.10310),
    createKnownHenrysLawConstant(10000, 160, 0.13116),
    createKnownHenrysLawConstant(10000, 200, 0.18490),
    createKnownHenrysLawConstant(10000, 250, 0.31259),
    createKnownHenrysLawConstant(10000, 300, 0.58389),
];
exports.knownPointsMoistAirPsychrometricProperties = [
    // From table A.11 in ASHRAE RP-1485
    createKnownMoistAirPsychrometricProperties(101.325, 200, 0.00, 45.07, 1.341, 202.52, 0.5558, NaN),
    createKnownMoistAirPsychrometricProperties(101.325, 200, 0.05, 55.38, 1.448, 346.49, 1.0299, NaN),
    createKnownMoistAirPsychrometricProperties(101.325, 200, 0.10, 61.85, 1.556, 490.43, 1.4736, NaN),
    createKnownMoistAirPsychrometricProperties(101.325, 200, 0.20, 69.95, 1.771, 778.24, 2.3336, NaN),
    createKnownMoistAirPsychrometricProperties(101.325, 200, 0.30, 75.00, 1.986, 1066.00, 3.1751, NaN),
    createKnownMoistAirPsychrometricProperties(101.325, 200, 0.40, 78.51, 2.201, 1353.71, 4.0059, NaN),
    createKnownMoistAirPsychrometricProperties(101.325, 200, 0.50, 81.12, 2.416, 1641.40, 4.8295, NaN),
    createKnownMoistAirPsychrometricProperties(101.325, 200, 0.60, 83.14, 2.630, 1929.06, 5.6479, NaN),
    createKnownMoistAirPsychrometricProperties(101.325, 200, 0.70, 84.76, 2.845, 2216.70, 6.4623, NaN),
    createKnownMoistAirPsychrometricProperties(101.325, 200, 0.80, 86.09, 3.060, 2504.32, 7.2736, NaN),
    createKnownMoistAirPsychrometricProperties(101.325, 200, 0.90, 87.20, 3.274, 2791.94, 8.0824, NaN),
    createKnownMoistAirPsychrometricProperties(101.325, 200, 1.00, 88.15, 3.489, 3079.55, 8.8890, NaN),
    // From table A.12 in ASHRAE RP-1485
    createKnownMoistAirPsychrometricProperties(1000, 200, 0.00, 90.47, 0.136, 201.94, -0.1033, NaN),
    createKnownMoistAirPsychrometricProperties(1000, 200, 0.05, 107.30, 0.147, 345.59, 0.3175, NaN),
    createKnownMoistAirPsychrometricProperties(1000, 200, 0.10, 117.69, 0.158, 488.96, 0.7078, NaN),
    createKnownMoistAirPsychrometricProperties(1000, 200, 0.20, 130.61, 0.179, 775.06, 1.4603, NaN),
    createKnownMoistAirPsychrometricProperties(1000, 200, 0.30, 138.66, 0.200, 1060.52, 2.1936, NaN),
    createKnownMoistAirPsychrometricProperties(1000, 200, 0.40, 144.29, 0.222, 1345.51, 2.9156, NaN),
    createKnownMoistAirPsychrometricProperties(1000, 200, 0.50, 148.49, 0.243, 1630.14, 3.6302, NaN),
    createKnownMoistAirPsychrometricProperties(1000, 200, 0.60, 151.76, 0.264, 1914.51, 4.3393, NaN),
    createKnownMoistAirPsychrometricProperties(1000, 200, 0.70, 154.39, 0.284, 2198.66, 5.0442, NaN),
    createKnownMoistAirPsychrometricProperties(1000, 200, 0.80, 156.56, 0.305, 2482.65, 5.7458, NaN),
    createKnownMoistAirPsychrometricProperties(1000, 200, 0.90, 158.37, 0.326, 2766.48, 6.4447, NaN),
    createKnownMoistAirPsychrometricProperties(1000, 200, 1.00, 159.92, 0.347, 3050.21, 7.1413, NaN),
    // From table A.13 in ASHRAE RP-1485
    createKnownMoistAirPsychrometricProperties(2000, 200, 0.00, 105.93, 0.068, 201.34, -0.3045, 0.0000),
    createKnownMoistAirPsychrometricProperties(2000, 200, 0.05, 125.81, 0.074, 344.62, 0.0999, 9.3474),
    createKnownMoistAirPsychrometricProperties(2000, 200, 0.10, 138.03, 0.079, 487.33, 0.4735, 17.4001),
    createKnownMoistAirPsychrometricProperties(2000, 200, 0.20, 153.19, 0.089, 771.37, 1.1917, 30.5663),
    createKnownMoistAirPsychrometricProperties(2000, 200, 0.30, 162.65, 0.100, 1054.02, 1.8898, 40.8763),
    createKnownMoistAirPsychrometricProperties(2000, 200, 0.40, 169.28, 0.110, 1335.62, 2.5760, 49.1686),
    createKnownMoistAirPsychrometricProperties(2000, 200, 0.50, 174.23, 0.120, 1616.41, 3.2542, 55.9827),
    createKnownMoistAirPsychrometricProperties(2000, 200, 0.60, 178.11, 0.130, 1896.55, 3.9264, 61.6816),
    createKnownMoistAirPsychrometricProperties(2000, 200, 0.70, 181.23, 0.140, 2176.18, 4.5941, 66.5182),
    createKnownMoistAirPsychrometricProperties(2000, 200, 0.80, 183.81, 0.150, 2455.37, 5.2582, 70.6745),
    createKnownMoistAirPsychrometricProperties(2000, 200, 0.90, 185.98, 0.160, 2734.21, 5.9192, 74.2847),
    createKnownMoistAirPsychrometricProperties(2000, 200, 1.00, 187.83, 0.169, 3012.74, 6.5779, 77.4497),
    // From table A.14 in ASHRAE RP-1485
    createKnownMoistAirPsychrometricProperties(5000, 200, 0.00, 126.87, 0.028, 199.72, -0.5738, 0.0000),
    createKnownMoistAirPsychrometricProperties(5000, 200, 0.05, 151.76, 0.030, 341.85, -0.1919, 21.5446),
    createKnownMoistAirPsychrometricProperties(5000, 200, 0.10, 166.94, 0.032, 482.36, 0.1580, 40.1050),
    createKnownMoistAirPsychrometricProperties(5000, 200, 0.15, 177.63, 0.034, 621.47, 0.4957, 56.2610),
    createKnownMoistAirPsychrometricProperties(5000, 200, 0.20, 185.72, 0.036, 759.33, 0.8256, 70.4514),
    createKnownMoistAirPsychrometricProperties(5000, 200, 0.25, 192.15, 0.037, 896.07, 1.1498, 83.0144),
    createKnownMoistAirPsychrometricProperties(5000, 200, 0.30, 197.42, 0.039, 1031.81, 1.4694, 94.2147),
    // From table A.15 in ASHRAE RP-1485
    createKnownMoistAirPsychrometricProperties(10000, 200, 0.00, 142.19, 0.014, 197.66, -0.7823, 0.0000),
    createKnownMoistAirPsychrometricProperties(10000, 200, 0.05, 171.31, 0.015, 337.69, -0.4188, 39.4628),
    createKnownMoistAirPsychrometricProperties(10000, 200, 0.10, 188.92, 0.016, 473.92, -0.0901, 73.4594),
    // From table A.16 in ASHRAE RP-1485
    createKnownMoistAirPsychrometricProperties(101.325, 320, 0.00, 54.90, 1.681, 326.93, 0.7901, NaN),
    createKnownMoistAirPsychrometricProperties(101.325, 320, 0.05, 62.07, 1.816, 482.76, 1.2864, NaN),
    createKnownMoistAirPsychrometricProperties(101.325, 320, 0.10, 67.00, 1.951, 638.58, 1.7525, NaN),
    createKnownMoistAirPsychrometricProperties(101.325, 320, 0.20, 73.54, 2.221, 950.20, 2.6573, NaN),
    createKnownMoistAirPsychrometricProperties(101.325, 320, 0.30, 77.79, 2.491, 1261.79, 3.5436, NaN),
    createKnownMoistAirPsychrometricProperties(101.325, 320, 0.40, 80.80, 2.761, 1573.35, 4.4191, NaN),
    createKnownMoistAirPsychrometricProperties(101.325, 320, 0.50, 83.07, 3.030, 1884.90, 5.2876, NaN),
    createKnownMoistAirPsychrometricProperties(101.325, 320, 0.60, 84.85, 3.300, 2196.45, 6.1508, NaN),
    createKnownMoistAirPsychrometricProperties(101.325, 320, 0.70, 86.28, 3.570, 2507.98, 7.0101, NaN),
    createKnownMoistAirPsychrometricProperties(101.325, 320, 0.80, 87.46, 3.840, 2819.51, 7.8663, NaN),
    createKnownMoistAirPsychrometricProperties(101.325, 320, 0.90, 88.45, 4.109, 3131.03, 8.7200, NaN),
    createKnownMoistAirPsychrometricProperties(101.325, 320, 1.00, 89.29, 4.379, 3442.54, 9.5715, NaN),
    // From table A.17 in ASHRAE RP-1485
    createKnownMoistAirPsychrometricProperties(1000, 320, 0.00, 107.70, 0.171, 326.80, 0.1318, NaN),
    createKnownMoistAirPsychrometricProperties(1000, 320, 0.05, 118.99, 0.185, 482.46, 0.5751, NaN),
    createKnownMoistAirPsychrometricProperties(1000, 320, 0.10, 126.74, 0.198, 637.99, 0.9880, NaN),
    createKnownMoistAirPsychrometricProperties(1000, 320, 0.20, 137.03, 0.225, 948.76, 1.7864, NaN),
    createKnownMoistAirPsychrometricProperties(1000, 320, 0.30, 143.73, 0.252, 1259.25, 2.5661, NaN),
    createKnownMoistAirPsychrometricProperties(1000, 320, 0.40, 148.52, 0.279, 1569.54, 3.3349, NaN),
    createKnownMoistAirPsychrometricProperties(1000, 320, 0.50, 152.14, 0.306, 1879.68, 4.0965, NaN),
    createKnownMoistAirPsychrometricProperties(1000, 320, 0.60, 154.99, 0.333, 2189.71, 4.8529, NaN),
    createKnownMoistAirPsychrometricProperties(1000, 320, 0.70, 157.29, 0.360, 2499.65, 5.6052, NaN),
    createKnownMoistAirPsychrometricProperties(1000, 320, 0.80, 159.19, 0.387, 2809.52, 6.3543, NaN),
    createKnownMoistAirPsychrometricProperties(1000, 320, 0.90, 160.79, 0.414, 3119.33, 7.1009, NaN),
    createKnownMoistAirPsychrometricProperties(1000, 320, 1.00, 162.16, 0.441, 3429.10, 7.8453, NaN),
    // From table A.18 in ASHRAE RP-1485
    createKnownMoistAirPsychrometricProperties(2000, 320, 0.00, 126.92, 0.086, 326.68, -0.0685, NaN),
    createKnownMoistAirPsychrometricProperties(2000, 320, 0.05, 140.12, 0.093, 482.14, 0.3586, NaN),
    createKnownMoistAirPsychrometricProperties(2000, 320, 0.10, 149.17, 0.099, 637.34, 0.7553, NaN),
    createKnownMoistAirPsychrometricProperties(2000, 320, 0.20, 161.20, 0.113, 947.16, 1.5209, NaN),
    createKnownMoistAirPsychrometricProperties(2000, 320, 0.30, 169.07, 0.126, 1256.39, 2.2674, NaN),
    createKnownMoistAirPsychrometricProperties(2000, 320, 0.40, 174.71, 0.140, 1565.21, 3.0031, NaN),
    createKnownMoistAirPsychrometricProperties(2000, 320, 0.50, 178.98, 0.153, 1873.73, 3.7313, NaN),
    createKnownMoistAirPsychrometricProperties(2000, 320, 0.60, 182.35, 0.166, 2182.01, 4.4542, NaN),
    createKnownMoistAirPsychrometricProperties(2000, 320, 0.70, 185.08, 0.179, 2490.11, 5.1730, NaN),
    createKnownMoistAirPsychrometricProperties(2000, 320, 0.80, 187.34, 0.192, 2798.06, 5.8885, NaN),
    createKnownMoistAirPsychrometricProperties(2000, 320, 0.90, 189.25, 0.206, 3105.89, 6.6014, NaN),
    createKnownMoistAirPsychrometricProperties(2000, 320, 1.00, 190.88, 0.219, 3413.63, 7.3122, NaN),
    // From table A.19 in ASHRAE RP-1485
    createKnownMoistAirPsychrometricProperties(5000, 320, 0.00, 154.63, 0.035, 326.46, -0.3351, NaN),
    createKnownMoistAirPsychrometricProperties(5000, 320, 0.05, 170.97, 0.037, 481.31, 0.0702, NaN),
    createKnownMoistAirPsychrometricProperties(5000, 320, 0.10, 182.17, 0.040, 635.49, 0.4447, NaN),
    createKnownMoistAirPsychrometricProperties(5000, 320, 0.20, 197.14, 0.045, 942.30, 1.1653, NaN),
    createKnownMoistAirPsychrometricProperties(5000, 320, 0.30, 206.99, 0.050, 1247.57, 1.8661, NaN),
    createKnownMoistAirPsychrometricProperties(5000, 320, 0.40, 214.10, 0.056, 1551.71, 2.5554, NaN),
    createKnownMoistAirPsychrometricProperties(5000, 320, 0.50, 219.52, 0.061, 1855.00, 3.2368, NaN),
    createKnownMoistAirPsychrometricProperties(5000, 320, 0.60, 223.82, 0.066, 2157.61, 3.9125, NaN),
    createKnownMoistAirPsychrometricProperties(5000, 320, 0.70, 227.33, 0.071, 2459.68, 4.5839, NaN),
    createKnownMoistAirPsychrometricProperties(5000, 320, 0.80, 230.25, 0.076, 2761.32, 5.2518, NaN),
    createKnownMoistAirPsychrometricProperties(5000, 320, 0.90, 232.72, 0.081, 3062.60, 5.9168, NaN),
    createKnownMoistAirPsychrometricProperties(5000, 320, 1.00, 234.85, 0.085, 3363.58, 6.5795, NaN),
    // From table A.20 in ASHRAE RP-1485
    createKnownMoistAirPsychrometricProperties(10000, 320, 0.00, 176.72, 0.018, 326.51, -0.5397, NaN),
    createKnownMoistAirPsychrometricProperties(10000, 320, 0.05, 195.85, 0.019, 480.31, -0.1514, NaN),
    createKnownMoistAirPsychrometricProperties(10000, 320, 0.10, 209.00, 0.020, 632.69, 0.2054, NaN),
    createKnownMoistAirPsychrometricProperties(10000, 320, 0.20, 226.64, 0.023, 934.11, 0.8889, NaN),
    createKnownMoistAirPsychrometricProperties(10000, 320, 0.30, 238.33, 0.025, 1232.07, 1.5511, NaN),
    createKnownMoistAirPsychrometricProperties(10000, 320, 0.40, 246.84, 0.028, 1527.38, 2.2005, NaN),
    createKnownMoistAirPsychrometricProperties(10000, 320, 0.50, 253.40, 0.030, 1820.58, 2.8409, NaN),
    createKnownMoistAirPsychrometricProperties(10000, 320, 0.60, 258.63, 0.032, 2112.05, 3.4747, NaN),
    createKnownMoistAirPsychrometricProperties(10000, 320, 0.70, 262.94, 0.034, 2402.07, 4.1033, NaN),
    createKnownMoistAirPsychrometricProperties(10000, 320, 0.80, 266.55, 0.036, 2690.85, 4.7277, NaN),
    createKnownMoistAirPsychrometricProperties(10000, 320, 0.90, 269.63, 0.039, 2978.55, 5.3486, NaN),
    createKnownMoistAirPsychrometricProperties(10000, 320, 1.00, 272.29, 0.041, 3265.32, 5.9666, NaN),
];
// From table A.1 in ASHRAE RP-1485
exports.knownWaterVaporSaturationOrSublimationPressures = [
    createKnownWaterVaporSaturationOrSublimationPressure(-130, 0.00000000087495),
    createKnownWaterVaporSaturationOrSublimationPressure(-120, 0.000000014054),
    createKnownWaterVaporSaturationOrSublimationPressure(-110, 0.00000016146),
    createKnownWaterVaporSaturationOrSublimationPressure(-100, 0.0000014049),
    createKnownWaterVaporSaturationOrSublimationPressure(-90, 0.0000096822),
    createKnownWaterVaporSaturationOrSublimationPressure(-80, 0.000054773),
    createKnownWaterVaporSaturationOrSublimationPressure(-70, 0.00026173),
    createKnownWaterVaporSaturationOrSublimationPressure(-60, 0.0010813),
    createKnownWaterVaporSaturationOrSublimationPressure(-50, 0.0039377),
    createKnownWaterVaporSaturationOrSublimationPressure(-40, 0.012841),
    createKnownWaterVaporSaturationOrSublimationPressure(-30, 0.038005),
    createKnownWaterVaporSaturationOrSublimationPressure(-20, 0.10324),
    createKnownWaterVaporSaturationOrSublimationPressure(-10, 0.25987),
    createKnownWaterVaporSaturationOrSublimationPressure(0, 0.61121),
    createKnownWaterVaporSaturationOrSublimationPressure(10, 1.2282),
    createKnownWaterVaporSaturationOrSublimationPressure(20, 2.3392),
    createKnownWaterVaporSaturationOrSublimationPressure(30, 4.2467),
    createKnownWaterVaporSaturationOrSublimationPressure(40, 7.3844),
    createKnownWaterVaporSaturationOrSublimationPressure(50, 12.351),
    createKnownWaterVaporSaturationOrSublimationPressure(60, 19.946),
    createKnownWaterVaporSaturationOrSublimationPressure(80, 47.415),
    createKnownWaterVaporSaturationOrSublimationPressure(100, 101.42),
    createKnownWaterVaporSaturationOrSublimationPressure(150, 476.10),
    createKnownWaterVaporSaturationOrSublimationPressure(200, 1554.7),
    createKnownWaterVaporSaturationOrSublimationPressure(250, 3975.9),
    createKnownWaterVaporSaturationOrSublimationPressure(300, 8587.7),
    createKnownWaterVaporSaturationOrSublimationPressure(350, 16529),
];
// Isothermal Compressibility of Liquid Water and Ice - From table A.5 in ASHRAE RP-1485
exports.knownIsothermalCompressibility = [
    // 101.325 kPa
    createKnownIsothermalCompressibility(101.325, -60, 0.10771),
    createKnownIsothermalCompressibility(101.325, -40, 0.11091),
    createKnownIsothermalCompressibility(101.325, -20, 0.11428),
    createKnownIsothermalCompressibility(101.325, 0, 0.50881),
    createKnownIsothermalCompressibility(101.325, 40, 0.44100),
    createKnownIsothermalCompressibility(101.325, 80, 0.46009),
    // 200 kPa
    createKnownIsothermalCompressibility(200, -60, 0.10770),
    createKnownIsothermalCompressibility(200, -40, 0.11090),
    createKnownIsothermalCompressibility(200, -20, 0.11427),
    createKnownIsothermalCompressibility(200, 0, 0.50867),
    createKnownIsothermalCompressibility(200, 40, 0.44089),
    createKnownIsothermalCompressibility(200, 80, 0.45996),
    createKnownIsothermalCompressibility(200, 120, 0.53059),
    // 500 kPa
    createKnownIsothermalCompressibility(500, -60, 0.10768),
    createKnownIsothermalCompressibility(500, -40, 0.11088),
    createKnownIsothermalCompressibility(500, -20, 0.11425),
    createKnownIsothermalCompressibility(500, 0, 0.50824),
    createKnownIsothermalCompressibility(500, 40, 0.44057),
    createKnownIsothermalCompressibility(500, 80, 0.45956),
    createKnownIsothermalCompressibility(500, 120, 0.52999),
    // 1,000 kPa
    createKnownIsothermalCompressibility(1000, -60, 0.10765),
    createKnownIsothermalCompressibility(1000, -40, 0.11085),
    createKnownIsothermalCompressibility(1000, -20, 0.11422),
    createKnownIsothermalCompressibility(1000, 0, 0.50753),
    createKnownIsothermalCompressibility(1000, 40, 0.44003),
    createKnownIsothermalCompressibility(1000, 80, 0.45890),
    createKnownIsothermalCompressibility(1000, 120, 0.52899),
    createKnownIsothermalCompressibility(1000, 160, 0.65791),
    // 2,000 kPa
    createKnownIsothermalCompressibility(2000, -60, 0.10758),
    createKnownIsothermalCompressibility(2000, -40, 0.11078),
    createKnownIsothermalCompressibility(2000, -20, 0.11415),
    createKnownIsothermalCompressibility(2000, 0, 0.50611),
    createKnownIsothermalCompressibility(2000, 40, 0.43895),
    createKnownIsothermalCompressibility(2000, 80, 0.45757),
    createKnownIsothermalCompressibility(2000, 120, 0.52699),
    createKnownIsothermalCompressibility(2000, 160, 0.65449),
    createKnownIsothermalCompressibility(2000, 200, 0.88083),
    // 5,000 kPa
    createKnownIsothermalCompressibility(5000, -60, 0.10737),
    createKnownIsothermalCompressibility(5000, -40, 0.11057),
    createKnownIsothermalCompressibility(5000, -20, 0.11394),
    createKnownIsothermalCompressibility(5000, 0, 0.50187),
    createKnownIsothermalCompressibility(5000, 40, 0.43575),
    createKnownIsothermalCompressibility(5000, 80, 0.45364),
    createKnownIsothermalCompressibility(5000, 120, 0.52112),
    createKnownIsothermalCompressibility(5000, 160, 0.64449),
    createKnownIsothermalCompressibility(5000, 200, 0.86130),
    createKnownIsothermalCompressibility(5000, 250, 1.44542),
    // 10,000 kPa
    createKnownIsothermalCompressibility(10000, -60, 0.10701),
    createKnownIsothermalCompressibility(10000, -40, 0.11022),
    createKnownIsothermalCompressibility(10000, -20, 0.11360),
    createKnownIsothermalCompressibility(10000, 0, 0.49490),
    createKnownIsothermalCompressibility(10000, 40, 0.43050),
    createKnownIsothermalCompressibility(10000, 80, 0.44725),
    createKnownIsothermalCompressibility(10000, 120, 0.51167),
    createKnownIsothermalCompressibility(10000, 160, 0.62867),
    createKnownIsothermalCompressibility(10000, 200, 0.83102),
    createKnownIsothermalCompressibility(10000, 250, 1.35647),
    createKnownIsothermalCompressibility(10000, 300, 3.05896),
];
function createKnownVirialCoefficient(temperature, // [°C]
baa, // [cm3/mol]
caaa, // [cm6/mol2]
bww, // [cm3/mol]
cwww, // [cm6/mol2]
baw, // [cm3/mol]
caaw, // [cm6/mol2]
caww) {
    return {
        temperature: temperature,
        baa: baa,
        caaa: caaa,
        bww: bww,
        cwww: cwww,
        baw: baw,
        caaw: caaw,
        caww: caww,
    };
}
function createKnownVirialCoefficientDerivative(temperature, // [°C]
dBaa_dT, // [cm3/(mol*K)]
dCaaa_dT, // [cm6/(mol2*K)]
dBww_dT, // [cm3/(mol*K)]
dCwww_dT, // [cm6/(mol2*K)]
dBaw_dT, // [cm3/(mol*K)]
dCaaw_dT, // [cm6/(mol2*K)]
dCaww_dT) {
    return {
        temperature: temperature,
        dBaa_dT: dBaa_dT,
        dCaaa_dT: dCaaa_dT,
        dBww_dT: dBww_dT,
        dCwww_dT: dCwww_dT,
        dBaw_dT: dBaw_dT,
        dCaaw_dT: dCaaw_dT,
        dCaww_dT: dCaww_dT,
    };
}
function createKnownEnhancementFactor(pressure, // [kPa]
temperature, // [°C]
enhancementFactor) {
    return {
        pressure: pressure,
        temperature: temperature,
        enhancementFactor: enhancementFactor,
    };
}
function createKnownHenrysLawConstant(pressure, // [kPa]
temperature, // [°C]
henrysLawConstant) {
    return {
        pressure: pressure,
        temperature: temperature,
        henrysLawConstant: henrysLawConstant,
    };
}
function createKnownMoistAirPsychrometricProperties(pressure, // [kPa]
dryBulb, // [°C]
humidityRatio, // [kg_w / kg_a]
wetBulb, // [°C]
specificVolume, // [m3/kg_a]
specificEnthalpy, // [m3/kg_a]
specificEntropy, // [kJ/(kg_a*K)]
relativeHumidity) {
    return {
        pressure: pressure,
        dryBulb: dryBulb,
        humidityRatio: humidityRatio,
        wetBulb: wetBulb,
        specificVolume: specificVolume,
        specificEnthalpy: specificEnthalpy,
        specificEntropy: specificEntropy,
        relativeHumidity: relativeHumidity,
    };
}
function createKnownWaterVaporSaturationOrSublimationPressure(temperature, // [°C]
waterVaporSaturationOrSublimationPressure) {
    return {
        temperature: temperature,
        waterVaporSaturationOrSublimationPressure: waterVaporSaturationOrSublimationPressure,
    };
}
function createKnownIsothermalCompressibility(pressure, // [kPa]
temperature, // [°C]
isothermalCompressibility) {
    return {
        pressure: pressure,
        temperature: temperature,
        isothermalCompressibility: isothermalCompressibility,
    };
}
